import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const propertyConfig = {
  /* ------------------------------- GET ----------------------------------- */

  getPropertyDetailsForOwner: {
    key: "getPropertyDetailsForOwner",
    url: "/api/v1/properties/my",
    method: "GET",
    options: {
      staleTime: STALE_TIME.LONG,
      gcTime: GC_TIME.EXTENDED,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      keepPreviousData: true,
      retry: 1,
      meta: { description: "Fetch property details for current user (pms-api)" },
    },
  },

  getPropertyDetails: {
    key: "getPropertyDetails",
    url: "/api/v1/properties/my",
    method: "GET",
    options: {
      retry: 2,
      staleTime: STALE_TIME.LONG,
      gcTime: GC_TIME.EXTENDED,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      keepPreviousData: true,
      meta: { description: "Fetch property details (pms-api)" },
    },
  },

  /* ------------------------------- PATCH ---------------------------------- */

  updateProperty: {
    key: "updateProperty",
    url: "/api/v1/properties/my",
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getPropertyDetailsForOwner", "getPropertyDetails"],
      onSuccessMessage: "Property updated successfully",
      onErrorMessage: "Failed to update property",
    },
  },

  /* ------------------------------- POST (legacy, keep for compat) --------- */

  createProperty: {
    key: "createProperty",
    url: "/api/v1/property?operation=createProperty",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getPropertyDetailsForOwner", "getPropertyDetails"],
      onSuccessMessage: "Property created successfully",
      onErrorMessage: "Failed to create property",
    },
  },

  uploadPropertyImage: {
    key: "uploadPropertyImage",
    mutationKey: ["property", "uploadImage"],
    url: (data) => {
      const docType = data instanceof FormData ? data.get("documentType") : data?.documentType;
      return `/api/v1/properties/upload-image?documentType=${docType || "logo"}`;
    },
    method: "POST",
    options: {
      invalidateKeys: ["getPropertyDetailsForOwner", "getPropertyDetails"],
    },
  },
};
